import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { assetUrl } from "@/lib/assets";

export default function Hero() {
  return (
    <>
      <section className="relative w-full overflow-hidden bg-graphite" data-testid="hero">
        {/* Background — full-bleed London skyline */}
        <div className="absolute inset-0" aria-hidden="true">
          <img
            src={assetUrl("/brand/london-skyline.jpg")}
            alt=""
            className="hero-bg-img"
            draggable={false}
          />
          <div className="hero-bg-scrim" />
        </div>

        {/* Foreground */}
        <div className="relative max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 min-h-[78vh] md:min-h-[86vh] flex flex-col justify-center pt-32 md:pt-36 pb-16 md:pb-20">
          <h1
            className="h-display text-warmwhite text-[clamp(1.7rem,4.0vw,3.6rem)] whitespace-nowrap drop-shadow-[0_2px_24px_rgba(0,0,0,0.35)]"
            data-testid="hero-headline"
          >
            CARLTON ELLEKER <span className="text-[#A8C0E6]">CHASE.</span>
          </h1>

          <div className="mt-10 md:mt-12 max-w-2xl">
            <p className="text-base md:text-lg text-warmwhite/95 leading-relaxed">
              <strong className="font-semibold">Carlton Elleker Chase</strong> is a full service
              multi sector law firm. We are commercial lawyers who act as trusted advisors to
              individuals and businesses all the way from start-up to PLC listings.
            </p>
            <p className="mt-5 text-base md:text-lg text-[#B6CDF0] leading-relaxed">
              It is our goal to understand your business and help you grow it. We are here to help.
            </p>
          </div>

          <div className="mt-10 md:mt-12 flex flex-wrap items-center gap-3 md:gap-4">
            <Link to="/expertise" className="cec-btn-onbg cec-btn-onbg-primary" data-testid="hero-cta-expertise">
              Our services <ArrowUpRight size={16} />
            </Link>
            <Link to="/people" className="cec-btn-onbg" data-testid="hero-cta-people">
              Meet the team
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
